import * as React from "react";

import { isDefinedAndTrue, toTitleCase } from "../common/services/Utilities";
import { Theme, Typography, TypographyProps } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

export interface Address {
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
}

export interface Props {
  addressObject: Address;
  wrapAddress?: boolean;
  align?: TypographyProps["align"];
  bold?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  boldAddress: {
    "& p": {
      fontWeight: "bold",
    },
  },
}));

export default function AddressDisplay({
  addressObject,
  wrapAddress,
  align,
  bold,
}: Props) {
  const styles = useStyles();
  const addressProps: TypographyProps = {
    noWrap: !wrapAddress,
    color: "primary",
    align: align ? align : "center",
  };
  return (
    <div className={bold ? styles.boldAddress : undefined}>
      {addressObject.address ? (
        // The split here is to avoid having an extra <p> tag in the html
        // This following code after also only splits the line between the last comma because of special cases referring to Suites
        addressObject.address.split(",").length > 1 ? (
          <>
            <Typography {...addressProps} id="main-address-line">
              {toTitleCase(
                addressObject.address.substring(
                  0,
                  addressObject.address.lastIndexOf(","),
                ),
              )}
            </Typography>
            <Typography {...addressProps} id="sub-address-line">
              {toTitleCase(
                addressObject.address.substring(
                  addressObject.address.lastIndexOf(",") + 1,
                  addressObject.address.length,
                ),
              )}
            </Typography>
          </>
        ) : (
          <>
            <Typography {...addressProps} id="main-address-line">
              {toTitleCase(addressObject.address)}
            </Typography>
            {isDefinedAndTrue(addressObject.address2) ? (
              <Typography {...addressProps} id="main-address-line2">
                {` ${toTitleCase(addressObject.address2)} `}
              </Typography>
            ) : (
              ""
            )}
          </>
        )
      ) : (
        ""
      )}
      <Typography {...addressProps} id="last-address-line">
        {`${addressObject.city ? `${toTitleCase(addressObject.city)}, ` : ""}${
          addressObject.state ? `${addressObject.state}` : ""
        } ${addressObject.zip ? addressObject.zip : ""}`.replace(
          /(^[,\s]+)|([,\s]+$)/g,
          "",
        )}
      </Typography>
    </div>
  );
}
